import { render, staticRenderFns } from "./RefundModal.vue?vue&type=template&id=2fa997d8&scoped=true&lang=pug"
import script from "./RefundModal.vue?vue&type=script&lang=js"
export * from "./RefundModal.vue?vue&type=script&lang=js"
import style0 from "./RefundModal.vue?vue&type=style&index=0&id=2fa997d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa997d8",
  null
  
)

export default component.exports